import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
} from "@angular/forms";
import {SelectionModel} from "@angular/cdk/collections";
import {MatTableDataSource} from "@angular/material/table";

import {VehicleService} from "@commons/services/vehicle/vehicle.service";
import {Vehicle} from "@commons/models/domain/Vehicle";

import {BaseComponent} from "@shared/components/base-component";

@Component({
  selector: 'dsm-vehicles-list',
  templateUrl: './vehicles-list.component.html',
  styleUrls: ['./vehicles-list.component.less'],
})
export class VehiclesListComponent extends BaseComponent implements OnInit, OnChanges, OnDestroy {

  @Input() selectedVehicles: number[] = [];

  @Output() selectionChanged = new EventEmitter<Vehicle[]>();

  isLoading = true;
  allVehicles: Vehicle[] = [];

  searchCtrl = new FormControl('');
  isSelectedAllCtrl = new FormControl(false);

  displayedColumns: string[] = ['select'];
  selectionModel = new SelectionModel<Vehicle>(true, []);
  dataSource: MatTableDataSource<Vehicle> = new MatTableDataSource<Vehicle>([]);

  form = this.formBuilder.group({
    search: this.searchCtrl,
    isSelectedAll: this.isSelectedAllCtrl
  });

  get currentFilter(): string {
    const filter = this.searchCtrl.value ? this.searchCtrl.value.toString() : '';
    return filter;
  }

  constructor(
    private formBuilder: FormBuilder,
    private vehicleService: VehicleService
  ) {
    super();

    this.dataSource.filterPredicate = this.filterPredicate;

    this.subToSelectedVehiclesChanges();
    this.subToSearchValueChanges();

    this.loadVehicles();
  }

  ngOnDestroy(): void {
    this.unsubscribeAll();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.selectedVehicles &&
      this.allVehicles &&
      this.selectedVehicles.length !== this.allVehicles.length) {
      this.isSelectedAllCtrl.setValue(false);
    }

    if (this.selectedVehicles) {
      this.selectionModel?.clear();
      const matchedFullVehicles = this.allVehicles.filter(x => this.selectedVehicles.some(sv => sv == x.Id));
      this.selectionModel.select(...matchedFullVehicles);
    }
  }

  ngOnInit(): void {
  }

  filterPredicate(vehicle: Vehicle, filter: string): boolean {
    filter = filter.toLowerCase();
    const result = vehicle.Nm.toLowerCase().includes(filter);
    return result;
  }

  onSelectAll() {
    const filtered = this.allVehicles.filter(x => this.filterPredicate(x, this.currentFilter));
    this.selectionModel.select(...filtered);
  }

  private subToSelectedVehiclesChanges() {
    this.addToUnsubscribe(
      this.selectionModel.changed.subscribe(() => {
        this.selectionChanged.emit(this.selectionModel.selected);
      })
    );
  }

  private subToSearchValueChanges() {
    this.addToUnsubscribe(
      this.searchCtrl.valueChanges.subscribe(filter => {
        if (filter || filter === '')
          this.dataSource.filter = filter.trim().toLowerCase();
      })
    );
  }

  private loadVehicles() {
    let interval = setInterval(() => {
      if (this.allVehicles.length === 0) {
        this.vehicleService.getList$().subscribe(vehicles => {
          this.isLoading = false;
          this.allVehicles = vehicles;
          this.dataSource.data = this.allVehicles;
        });
      }
      else {
        clearInterval(interval);
      }
    }, 100);
  }

}
